<template>
  <div class="highlight_moudle">
    <p style="font-size: 24px; margin-bottom: 20px">Core functions</p>
    <p style="font-size: 72px; font-weight: 700; margin-bottom: 90px">Illuminating Visions</p>
    <div class="highlight_content">
      <div class="image-container">
        <div class="image-wrapper" :style="{ transform: `translateX(-${currentIndex * (931 + 80)}px)`, opacity: imageOpacity, transition: 'transform 1.2s ease' }">
          <img 
            v-for="(img, index) in imgList" 
            :key="index" 
            :src="img" 
            :alt="`Image ${index}`" 
            :class="{ 'highlighted': currentIndex === index }"
            style="width: 931px; height: 568px;" 
          />
        </div>
      </div>
      <div class="tab">
        <span
          v-for="(item, index) in tabName"
          :key="index"
          @click="tab(index)"
          :class="{ active: currentIndex === index }"
        >{{ item }}</span>
      </div>
      <p class="box" :style="{ opacity: textOpacity, transition: 'opacity 0.6s ease' }">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabName: "",
      imgList: "",
      msgList: "",
      imgUrl: "",
      msg: "",
      currentIndex: 0,
      imageOpacity: 1,
      textOpacity: 1
    };
  },
  props: {
    Info: {
      type: Object,
      default: () => {},
    },
  },
  beforeMount() {
    this.tabName = this.Info.tabName;
    this.imgList = this.Info.imgList;
    this.imgUrl = this.imgList[0];
    this.msgList = this.Info.msgList;
    this.msg = this.msgList[0];
  },
  watch: {
    Info: {
      immediate: true,
      handler(newValue) {
        this.tabName = newValue.tabName;
        this.imgList = newValue.imgList;
        this.imgUrl = this.imgList[0];
        this.msgList = newValue.msgList;
        this.msg = this.msgList[0];
      },
    },
    currentIndex: {
      handler(newIndex) {
        // 先将图片和文字的 opacity 设为 0
        this.imageOpacity = 0;
        this.textOpacity = 0;
        this.$nextTick(() => {
          // 在 DOM 更新后，再将图片和文字的 opacity 设为 1，触发渐入动画
          this.imageOpacity = 1;
          this.textOpacity = 1;
        });
      }
    }
  },
  methods: {
    tab(index) {
      setTimeout(() => {
        this.currentIndex = index;
        this.imgUrl = this.imgList[index];
        this.msg = this.msgList[index];

        // 先将图片和文字的 opacity 设为 0
        this.imageOpacity = 0;
        this.textOpacity = 0;
        this.$nextTick(() => {
          // 在 DOM 更新后，再将图片和文字的 opacity 设为 1，触发渐入动画
          this.imageOpacity = 1;
          this.textOpacity = 1;
        });
      }, 300); 
    }
  },
};
</script>

<style scoped lang="scss">
.highlight_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 80px 0 50px;
}

.image-container {
  width: 100%;
  position: relative;
  left: 120px;
  transition: left 0.3s ease;
}

.image-wrapper {
  display: flex;
  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.6s ease;
  left: 0;
  gap: 80px;
}

.highlighted {
  filter: brightness(1); /* 选中的图片亮度为1，即正常亮度 */
  transition: filter 1.5s ease; /* 添加过渡效果，使亮度变化更平滑 */
}

img:not(.highlighted) {
  filter: brightness(0.5); /* 未选中的图片亮度为0.5，可以根据需要调整 */
  transition: filter 0.3s ease; /* 添加过渡效果，使亮度变化更平滑 */
}

.tab {
  display: flex;
  border-bottom: 1px #383838 solid;
  margin: 50px 0 30px;
}

.tab span {
  display: block;
  padding: 16px;
  font-size: 20px;
  text-align: center;
  color: #818186;
  transition: color 0.3s ease, border-bottom 0.3s ease;
  cursor: pointer;
}

.tab .active {
  color: #fff;
  border-bottom: 2px #ccc solid;
}

.box {
  width: 1030px;
  height: 100px;
  color: #818186;
  font-size: 20px;
}
</style>